import { render, staticRenderFns } from "./QuoteComparativeTable.vue?vue&type=template&id=38743eb4&scoped=true&"
import script from "./QuoteComparativeTable.vue?vue&type=script&lang=js&"
export * from "./QuoteComparativeTable.vue?vue&type=script&lang=js&"
import style0 from "./QuoteComparativeTable.vue?vue&type=style&index=0&id=38743eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38743eb4",
  null
  
)

export default component.exports